import { 
    SWITCH_MODEL_DISTRIBUTION_GRAPH_GET,
    SWITCH_MODEL_DISTRIBUTION_GRAPH_GET_SUCCESS,
    SWITCH_MODEL_DISTRIBUTION_GRAPH_GET_GET_FAIL,
    SWITCH_TRAFFIC_PERFORMANCE_GRAPH_API_SUCCESS,
    SWITCH_TRAFFIC_PERFORMANCE_GRAPH_API_FAIL,
    SWITCH_TRAFFIC_PERFORMANCE_GRAPH_API_REQUEST
 } from "../../constants/switchConstants";
 
 export const SwitchModelCountReducer = (state = { 
   graphData: {} ,
   loading : false,
   switchTraffic : {
    loading: true,
    data: [],
    error: null
   }
  },action) => {
    switch (action.type) {
        case SWITCH_MODEL_DISTRIBUTION_GRAPH_GET:
          return {
            ...state,
            loading: true,
          };
        case SWITCH_MODEL_DISTRIBUTION_GRAPH_GET_SUCCESS:
          return {
            ...state,
            loading: false,
            graphData: action.payload,
          };
        case SWITCH_MODEL_DISTRIBUTION_GRAPH_GET_GET_FAIL:
          return {
            ...state,
            loading: false,
            error: action.payload,
          };
        case SWITCH_TRAFFIC_PERFORMANCE_GRAPH_API_REQUEST:
          return {
              ...state,
            switchTraffic: {
              loading: true,
              data: [],
              error: null
            }
          };
        case SWITCH_TRAFFIC_PERFORMANCE_GRAPH_API_SUCCESS:
          return {
            ...state,
            switchTraffic: {
              loading: false,
              data: action.payload,
              error: null
            }
          };
        case SWITCH_TRAFFIC_PERFORMANCE_GRAPH_API_FAIL:
          return {
            ...state,
            switchTraffic: {
              loading: false,
              data: [],
              error: null
            }
          };
        default:
          return state;
      }
 }